export default __webpack_public_path__ + "static/media/MaisonNeue-Bold.9d9cdd85.woff2";